import Button from "@mui/material/Button";
import { IconButton } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Text from "./Text";
import { useState } from 'react';
import { Col, Row } from "./Flexbox";
import TextContainer from "./TextContainer";
import { verifyPassword } from "../scripts/functions/AuthService";
const VerifyPassword = ({theme, message, title, email, btnText, onSuccess, onClose}) => {

    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleVerification = async (e) => {
        if (e) e.preventDefault();
        if (!password) return;

        const isValid = await verifyPassword(email, password);

        if (isValid) {
            onSuccess();
            onClose();
        }
           
    }

    const isDark = theme.White !== "#FFFFFF";

    return (
        <form onSubmit={handleVerification}>
            <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box'}}>
                <Col style={{width:'100%', height: '100%', maxWidth: '450px', maxHeight: '250px', flex:'none', alignItems:'flex-start', paddingLeft: 32, paddingRight: 32, paddingTop: 32, paddingBottom: 32, marginTop: 32, backgroundColor: theme.White,  borderRadius: 4, boxShadow: isDark ? '0px 10px 40px rgba(0, 0, 0, 0.8)' : '0px 10px 30px rgba(0, 0, 0, 0.1)'}}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'start', width: '100%', marginTop: '30px'}}>
                        <Text color={theme.Black} size={21} weight={800}>{title}</Text>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 4, position: 'relative', marginTop: '30px'}}>
                        <Text color={theme.Black} size={15} weight={400}>{message}</Text>
                        <TextContainer type={showPassword ? "text" : "password"} autoComplete="current-password" style={{width: '100%', height: 36}} value={password} theme={theme} placeHolder="Contraseña" onChange={(value) => setPassword(value)} endIcon={<IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" style={{color: theme.Lao}}>{showPassword ? <VisibilityOff/> : <Visibility/>}</IconButton>}/>
                    </div>
                    <Row style={{width: '100%', justifyContent: 'space-between', paddingTop: 40, gap: 16}}>
                        <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={onClose} color={theme.Lao} size={15}>Cancelar</Text>
                        <Button type="submit" disabled={!password} variant="contained" sx={{height: 20, backgroundColor: 'transparent', color: !password ? theme.Ey : theme.Magenta, fontSize: 15, textTransform: 'none', '&.Mui-disabled': {color: !password ? theme.Audi : theme.Magenta}}}>{btnText}</Button>
                    </Row>
                </Col>
            </div>
        </form>
        
    )
}

export default VerifyPassword;